import { render, staticRenderFns } from "./TestScreen.vue?vue&type=template&id=4cdedd30&scoped=true&"
import script from "./TestScreen.vue?vue&type=script&lang=js&"
export * from "./TestScreen.vue?vue&type=script&lang=js&"
import style0 from "./TestScreen.vue?vue&type=style&index=0&id=4cdedd30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdedd30",
  null
  
)

export default component.exports